export const proEstate = {
  id: "pro-estate",
  code: "01",
  brand: "PRO ESTATE",
  nameJa: "不動産管理",
  nameEn: "Real Estate Management",
  accent: "primary",
  icon: "ri-building-4-line",
  taglineJa: "売買から賃貸管理まで、資産価値を守り育てる不動産パートナー。",
  taglineEn: "A property partner that protects and grows asset value.",
  leadJa:
    "都心マンション・投資用物件・法人社宅まで、取得のご相談から日々の運営、出口戦略の設計までを一つのチームで担当します。宅地建物取引士と不動産経営の専門家が、オーナー様の判断に必要な材料を揃えてご提案します。",
  leadEn:
    "One team covers the full life cycle of your property — acquisition, leasing, daily operations and exit planning — backed by licensed real estate advisors.",
  heroImage:
    "/images/proestate.jpg",
  stats: [
    { value: "1,200", unit: "戸", labelJa: "累計管理戸数", labelEn: "Units managed" },
    { value: "38", unit: "日", labelJa: "平均媒介日数", labelEn: "Average days to close" },
    { value: "92", unit: "%", labelJa: "成約率", labelEn: "Deal closing rate" },
    { value: "1都3県", unit: "", labelJa: "主要対応エリア", labelEn: "Tokyo metropolitan area" },
  ],
  challenges: [
    {
      icon: "ri-door-lock-line",
      titleJa: "空室が埋まらない",
      titleEn: "Vacancy drags on",
      descJa: "募集条件が昔のまま更新されず、相場とずれた家賃で空室期間が長引いていませんか。",
    },
    {
      icon: "ri-eye-off-line",
      titleJa: "管理会社の対応が見えない",
      titleEn: "No visibility",
      descJa: "修繕の判断も収支の報告も任せきりで、何にいくら使われたのか分からない状態になっていませんか。",
    },
    {
      icon: "ri-question-line",
      titleJa: "売却のタイミングが分からない",
      titleEn: "Exit timing unclear",
      descJa: "保有を続けるべきか、売るべきか。判断材料となる数字が手元に揃っていないケースが多くあります。",
    },
  ],
  strengths: [
    {
      icon: "ri-shield-user-line",
      titleJa: "宅建士・不動産経営士の在籍",
      titleEn: "Licensed advisors",
      descJa: "宅地建物取引士と不動産経営の専門資格を持つスタッフが、法令面と収益面の両方からご提案します。",
    },
    {
      icon: "ri-community-line",
      titleJa: "自社ネットワークでの客付け",
      titleEn: "In-house tenant pipeline",
      descJa: "提携仲介店舗と自社の反響データを組み合わせ、募集条件を週次で見直しながら入居者を探します。",
    },
    {
      icon: "ri-file-chart-line",
      titleJa: "月次レポートの完全開示",
      titleEn: "Full monthly reporting",
      descJa: "入退去・収支・修繕履歴を毎月デジタルで共有。オーナー様がいつでも判断できる状態を保ちます。",
    },
    {
      icon: "ri-route-line",
      titleJa: "出口戦略まで一貫支援",
      titleEn: "Built-in exit strategy",
      descJa: "運用の途中から売却のシナリオを並行して検討し、相場のタイミングを逃さない体制で動きます。",
    },
  ],
  menu: [
    {
      icon: "ri-key-2-line",
      titleJa: "賃貸仲介・賃貸管理",
      titleEn: "Leasing & property management",
      descJa: "入居者募集から審査、契約、更新、退去精算、原状回復までを一括で対応します。",
    },
    {
      icon: "ri-hand-coin-line",
      titleJa: "売買仲介",
      titleEn: "Sales brokerage",
      descJa: "価格査定から販売戦略の設計、広告出稿、内見調整、契約決済までを担当します。",
    },
    {
      icon: "ri-team-line",
      titleJa: "法人社宅・一括借上げ",
      titleEn: "Corporate housing",
      descJa: "福利厚生としての社宅制度設計から、借上げ契約、入退去の事務までまとめて支援します。",
    },
    {
      icon: "ri-pie-chart-2-line",
      titleJa: "資産診断・ポートフォリオ設計",
      titleEn: "Portfolio advisory",
      descJa: "保有物件の収支と市場価値を棚卸しし、買い増し・組み替え・売却の選択肢を数値で比較します。",
    },
    {
      icon: "ri-hammer-line",
      titleJa: "リノベーション・原状回復",
      titleEn: "Renovation support",
      descJa: "空室対策としてのリノベ提案、退去時の原状回復工事の見積もり・立ち会いまで対応します。",
    },
  ],
  highlight: {
    value: "0円",
    labelJa: "貸主さまの仲介手数料は無料",
    labelEn: "Zero brokerage fee for owners",
    descJa:
      "空室期間は家賃収入が止まるうえ、原状回復や広告費もかさむもの。PRO ESTATEでは、オーナーさまの客付け手数料をいただいていません。",
    points: ["入居者さまの負担は賃料1ヶ月分（税別）", "売買仲介は売主・買主それぞれ成約価格の1.5%（1億円以上は1%）", "管理料は賃料の5%（税別・月額）"],
  },
  pricing: [
    {
      nameJa: "賃貸仲介",
      nameEn: "Leasing brokerage",
      price: "借主 賃料1ヶ月分",
      priceNote: "貸主 仲介手数料 無料 / 借主分は税別",
      descJa: "入居者さまは賃料1ヶ月分、貸主さまは無料。契約後の運営は月額の賃貸管理プランで承ります。",
      features: [
        "貸主さまの仲介手数料は無料",
        "入居者募集・反響集客",
        "入居審査・契約手続き",
        "内見調整・条件交渉",
        "契約後の管理もご相談可",
      ],
      recommended: false,
    },
    {
      nameJa: "賃貸管理",
      nameEn: "Property management",
      price: "賃料の 5%",
      priceNote: "税別 / 月額（賃料の5%または5,000円のいずれか高い方）",
      descJa: "入居後の運営をまるごとお任せ。空室対応から収支報告までを担当します。",
      features: [
        "家賃の集金・督促",
        "入居者さまからの連絡窓口",
        "退去精算・原状回復の手配",
        "月次収支レポートの共有",
      ],
      recommended: false,
    },
    {
      nameJa: "売買仲介",
      nameEn: "Sales brokerage",
      price: "成約価格の 1.5%",
      priceNote: "売主・買主それぞれ / 税別（1億円以上は1%）",
      descJa: "保有物件の売却を、相場に沿った価格で進めたい方へ。売主さま・買主さまそれぞれから申し受けます。",
      features: ["無料価格査定", "販売戦略の設計", "ポータル広告出稿", "内見調整・契約手続き", "売主・買主それぞれ1.5%"],
      recommended: true,
    },
    {
      nameJa: "資産コンサルプラン",
      nameEn: "Asset advisory",
      price: "月額 50,000円〜",
      priceNote: "税別",
      descJa: "複数物件をお持ちで、全体最適を考えたい方へ。",
      features: ["ポートフォリオ診断", "年間収支シミュレーション", "出口戦略の設計", "四半期ごとの面談"],
      recommended: false,
    },
  ],
  priceNoteJa:
    "賃貸仲介手数料は借主さま賃料1ヶ月分（税別）、貸主さまは無料です。賃貸管理は賃料の5%（税別・月額、最低5,000円）。売買仲介手数料は売主さま・買主さまそれぞれから成約価格の1.5%（1億円以上の物件は1%）（税別）を申し受けます。表示金額はすべて税別の目安です。",
  flow: [
    { step: "01", titleJa: "無料相談", titleEn: "Consultation", descJa: "オンライン30分で、保有状況とご希望をお伺いします。" },
    { step: "02", titleJa: "現地・資料確認", titleEn: "Assessment", descJa: "物件資料と周辺相場を確認し、現状の収益を整理します。" },
    { step: "03", titleJa: "ご提案", titleEn: "Proposal", descJa: "運用方法・募集条件・売却シナリオを数字付きでご提示します。" },
    { step: "04", titleJa: "契約・運用開始", titleEn: "Kick-off", descJa: "契約締結後、担当者が専任で運用をスタートします。" },
  ],
  faq: [
    { q: "貸主側の仲介手数料が無料なのはなぜですか？", a: "空室期間は家賃収入が止まるうえ、原状回復や広告費もかさみます。せめて客付けの手数料は負担ゼロにしたいという考えから、貸主さまの仲介手数料は無料としています。入居者さまの負担は賃料1ヶ月分（税別）です。" },
    { q: "仲介手数料はいつ支払うのですか？", a: "賃貸・売買ともに、契約が成立した時点でお支払いいただきます（税別）。成約に至らなかった場合は仲介手数料はかかりません。" },
    { q: "管理戸数が1戸だけでも相談できますか？", a: "はい、1戸からお受けしています。むしろ1戸だからこそ、募集条件の見直しなど細かい改善が効きやすいケースもあります。" },
    { q: "首都圏以外の物件も対応できますか？", a: "首都圏を主な対応エリアとしていますが、提携ネットワークを通じて地方物件のご相談も承ります。まずはご状況をお聞かせください。" },
    { q: "売買の仲介手数料は売主・買主のどちらが払うのですか？", a: "売主さま・買主さまそれぞれから、成約価格の1.5%（1億円以上の物件は1%）を税別で申し受けます。いずれか一方にご負担を寄せることはしておりませんので、双方にとって条件が透明になります。" },
    { q: "売却だけの相談でも大丈夫ですか？", a: "可能です。価格査定のみのご依頼も承っています。売却後に賃貸へ切り替えるプランのご提案もできます。" },
    { q: "管理契約の途中解約はできますか？", a: "1ヶ月前のご予告で解約いただけます。違約金はいただいておりません。" },
  ],
  related: ["marketing-quest", "pro-online"],
};